import { Action, createReducer, on } from '@ngrx/store';
import { IAnalyticsState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import { Report } from '../../generated/CrossPoint.Analytics.Server/model/report';
import { calculateReportRegenerationFailedAction, calculateReportRegenerationSuccessAction, createReportSuccessAction, deleteReportSuccessAction, getAuthInfoAnalyticsFailedAction, getAuthInfoAnalyticsSuccessAction, getDemoStatisticsSuccessAction, getLocalesSuccessAction, getMatchingStoresFailedAction, getMatchingStoresSuccessAction, getReportsFailedAction, getReportsSuccessAction, getRetailerLicenseFailedAction, getRetailerLicenseSuccessAction, getTierLimitsFailedAction, getTierLimitsSuccessAction, getTimeZonesSuccessAction, updateReportSuccessAction } from '../actions/analytics.actions';
import { SubscriptionTier } from 'src/app/generated/CrossPoint.Analytics.Server';

const initialState: IAnalyticsState = {
  permission: null,
  reports: null,
  timeZones: null,
  matchingStores: null,
  reportPreview: null,
  locales: null,
  retailerLicense: null,
  tierLimits: null,
  demo: null,
};

export const analyticsReducerImplicit = createReducer(
  initialState,
  on(getRetailerLicenseSuccessAction, (state, { data: license }) => ({
    ...state,
    retailerLicense: license,
  })),
  on(getRetailerLicenseFailedAction, (state, { data: retailerId }) => ({
    ...state,
    retailerLicense: {
      activeSinceUtc: '',
      retailerId: retailerId,
      tier: SubscriptionTier.Bronze,
      limitations: {
        dataFormats: {},
        graphs: {},
        maxReports: 1,
        reportTypes: {},
        transferMethods: {}
      }
    },
  })),
  on(getTierLimitsSuccessAction, (state, {data: tierLimits}) => ({
    ...state,
    tierLimits: tierLimits,
  })),
  on(getAuthInfoAnalyticsSuccessAction, (state, { data: permission }) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoAnalyticsFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
  on(getReportsSuccessAction, (state, { data: reports }) => ({
    ...state,
    reports,
  })),
  on(calculateReportRegenerationSuccessAction, (state, { data: reportPreview }) => ({
    ...state,
    reportPreview,
  })),
  on(calculateReportRegenerationFailedAction, (state) => ({
    ...state,
    // Magic value to indicate this was a failure
    reportPreview: {
      timestampsUtc: null,
      stores: 0,
      maxReports: 0,
    }
  })),
  on(getMatchingStoresSuccessAction, (state, { data: matchingStores }) => ({
    ...state,
    matchingStores,
  })),
  on(getMatchingStoresFailedAction, (state,) => ({
    ...state,
    matchingStores: null
  })),  
  on(getReportsFailedAction, (state,) => ({
    ...state,
    reports: null,
  })),
  on(createReportSuccessAction, (state, { data: report }) => ({
    ...state,
    reports: [...(state.reports ?? []), report],
  })),
  on(updateReportSuccessAction, (state, { data: report }) => ({
    ...state,
    reports: [...(state.reports ?? []).filter(r => r.reportId !== report.reportId), report],
  })),
  on(deleteReportSuccessAction, (state, { data: report }) => ({
    ...state,
    reports: state.reports?.filter((report: Report) => report.reportId !== report.reportId) ?? [],
  })),
  on(getTimeZonesSuccessAction, (state, { data: timeZones }) => ({
    ...state,
    timeZones: timeZones,
  })),
  on(getLocalesSuccessAction, (state, { data: locales }) => ({
    ...state,
    locales: locales,
  })),
  on(getDemoStatisticsSuccessAction, (state, { data: demoCount }) => ({
    ...state,
    demo: demoCount,
  })),
);

export function analyticsReducer(state: any, action: Action): IAnalyticsState {
  return analyticsReducerImplicit(state, action);
}
